<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'detail'">Chi tiết tour du lịch</span>
        <span v-if="mData.viewMode == 'accept'">Duyệt tour du lịch</span>
        <span v-if="mData.viewMode == 'update'">Cập nhật tour du lịch</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm" label-width="100%" label-position="top">
          <b-row>
            <b-col md="4">
              <el-form-item label="Tên tour" prop="ten_tour">
                <el-input v-model="mData.dataForm.ten_tour"
                  :disabled="mData.viewMode == 'accept' || mData.viewMode == 'detail'" clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Tên công ty" prop="cong_ty_lu_hanh.ten.vi">
                <el-input v-model="mData.dataForm.cong_ty_lu_hanh.ten.vi" disabled clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Địa chỉ" prop="cong_ty_lu_hanh.dia_chi.dia_chi">
                <el-input v-model="mData.dataForm.cong_ty_lu_hanh.dia_chi.dia_chi" disabled clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Email" prop="cong_ty_lu_hanh.email">
                <el-input v-model="mData.dataForm.cong_ty_lu_hanh.email" disabled clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Điện thoại" prop="cong_ty_lu_hanh.dien_thoai">
                <el-input v-model="mData.dataForm.cong_ty_lu_hanh.dien_thoai" disabled clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Website" prop="cong_ty_lu_hanh.website">
                <el-input v-model="mData.dataForm.cong_ty_lu_hanh.website" disabled clearable></el-input>
              </el-form-item>
            </b-col>
            <!-- <b-col md="3">
              <el-form-item label="Thời gian bắt đầu" prop="hanh_trinh.thoi_gian_bat_dau">
                <el-date-picker
                  v-model="mData.dataForm.hanh_trinh.thoi_gian_bat_dau"
                  :disabled="mData.viewMode == 'accept' || mData.viewMode == 'detail'"
                  type="datetime"
                  clearable
                ></el-date-picker>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Thời gian kết thúc" prop="hanh_trinh.thoi_gian_ket_thuc">
                <el-date-picker
                  v-model="mData.dataForm.hanh_trinh.thoi_gian_ket_thuc"
                  :disabled="mData.viewMode == 'accept' || mData.viewMode == 'detail'"
                  type="datetime"
                  clearable
                ></el-date-picker>
              </el-form-item>
            </b-col> -->
            <b-col md="2">
              <el-form-item label="Địa điểm bắt đầu" prop="hanh_trinh.dia_diem_bat_dau">
                <!-- <el-input
                  v-model="mData.dataForm.hanh_trinh.dia_diem_bat_dau"
                  :disabled="mData.viewMode == 'accept' || mData.viewMode == 'detail'"
                  clearable
                ></el-input> -->
                <el-select v-model="mData.dataForm.hanh_trinh.dia_diem_bat_dau" :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'accept' || mData.viewMode == 'detail'" clearable filterable>
                  <el-option v-for="item in mData.dataDefault.listProvince" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-form-item label="Địa điểm kết thúc" prop="hanh_trinh.dia_diem_ket_thuc">
                <el-select v-model="mData.dataForm.hanh_trinh.dia_diem_ket_thuc" :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'accept' || mData.viewMode == 'detail'" clearable filterable>
                  <el-option v-for="item in mData.dataDefault.listProvince" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-form-item label="Ngôn ngữ" prop="ngon_ngu" class="label-required">
                <el-select v-model="mData.dataForm.ngon_ngu" :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'accept' || mData.viewMode == 'detail'" clearable filterable>
                  <el-option v-for="item in mData.dataDefault.listNgonNgu" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-form-item label="Loại hình ưu đãi" prop="loai_hinh_uu_dai">
                <el-select v-model="mData.dataForm.loai_hinh_uu_dai" :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'accept' || mData.viewMode == 'detail'" clearable filterable
                  @change="fn_selectTypeEndow(mData.dataForm.loai_hinh_uu_dai)">
                  <el-option v-for="item in mData.dataDefault.listEndow" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="3" v-if="showInputMoney">
              <el-form-item
                label="Giá trị ưu đãi VND"
                prop="gia_tri_uu_dai"
                :rules="rulesGiaTriUuDai"
              >
                <ElementUiMoney
                  :value="mData.dataForm.gia_tri_uu_dai"
                  placeholder="Nhập giá trị ưu đãi"
                  :disabled="
                    mData.viewMode == 'accept' || mData.viewMode == 'detail'
                  "
                  :clearable="true"
                  @input="handleInputGiaTriUuDai"
                />
              </el-form-item>
            </b-col>
            <b-col md="3" v-if="showInputPercent">
              <el-form-item
                label="Giá trị ưu đãi %"
                prop="gia_tri_uu_dai"
                :rules="rulesGiaTriUuDaiPercent"
              >
                <el-input
                  v-model="mData.dataForm.gia_tri_uu_dai"
                  placeholder="Nhập giá trị ưu đãi"
                  :disabled="
                    mData.viewMode == 'accept' || mData.viewMode == 'detail'
                  "
                  clearable
                  @input="handleInputGiaTriUuDai"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-card>
            <div slot="header">
              Link đặt dịch vụ
            </div>
            <b-row>
              <b-col md="4" lg="3" cols="12" v-for="item in mData.dataForm.thong_tin_chung.link_dich_vu" :key="item.id">
                <el-form-item :label="'Link ' + (item.ten ? item.ten : '')" prop="">
                  <el-input v-model="item.link" :disabled="mData.viewMode == 'accept' || mData.viewMode == 'detail'"
                    @input="forceUpdateUI" clearable></el-input>
                </el-form-item>
              </b-col>
            </b-row>
          </b-card>
          <b-card>
            <div slot="header">
              Link liên kết mạng xã hội
            </div>
            <b-row>
              <b-col md="4" lg="3" cols="12" v-for="(item, index) in mData.dataForm.thong_tin_chung.link_mang_xa_hoi"
                :key="index">
                <el-form-item :label="'Link ' + (item.name ? item.name : '')"
                  :prop="`thong_tin_chung.link_mang_xa_hoi[${index}].link`">
                  <el-input v-model="item.link" :disabled="mData.viewMode == 'accept' || mData.viewMode == 'detail'"
                    @input="forceUpdateUI" clearable></el-input>
                </el-form-item>
              </b-col>
            </b-row>
          </b-card>
          <b-row>
            <b-col md="2" style="margin-bottom: 10px;">
              <el-form-item class="mb-3" label="Ảnh đại diện" prop="mediaId">
                <el-upload action :auto-upload="false" list-type="picture-card"
                  :limit="mData.fileUploadOption.AnhDaiDien.limit" :accept="mData.fileUploadOption.AnhDaiDien.accept"
                  :on-change="fn_uploadChangeAnhDaiDien" :on-preview="fn_uploadPreviewAnhDaiDien"
                  :on-remove="fn_uploadRemoveAnhDaiDien" :on-exceed="fn_uploadExceedAnhDaiDien"
                  :file-list="mData.fileUploadOption.AnhDaiDien.fileList"
                  :disabled="mData.viewMode == 'accept' || mData.viewMode == 'detail'"
                  :class="[mData.fileUploadOption.AnhDaiDien.fileList.length > 0 ? 'hidden-icon-upload' : '']">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :close-on-click-modal="true" :visible.sync="mData.fileUploadOption.AnhDaiDien.dialogVisible"
                  width="60%" top="51px" title="Chi tiết">
                  <img width="100%" :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </b-col>
            <b-col md="10">
              <b-col md="4">
                <label class="el-form-item__label">Trạng thái:</label> <span
                  style="font-size: 14px; padding: 0.4em 0.4em;" class="badge badge-pill ml-2"
                  :class="{ 'badge-secondary': getStatusName == 'Từ chối', 'badge-primary': getStatusName == 'Chờ duyệt', 'badge-info': getStatusName == 'Đang soạn thảo', }">{{
                    getStatusName
                  }}</span>
              </b-col>
              <b-col md="12" v-if="mData.dataForm.ly_do_tu_choi">
                <el-form-item label="Lý do từ chối" prop="dich_vu.ly_do_tu_choi">
                  <el-input v-model="mData.dataForm.ly_do_tu_choi" type="textarea" :rows="5" disabled
                    clearable></el-input>
                </el-form-item>
              </b-col>
            </b-col>
            <b-col md="12">
              <el-form-item class="mb-0" label="Địa chỉ trên bản đồ" prop="">
                <mapbox-component :viewMode="mData.viewMode" @update="fn_getDataFromMapboxComponent"
                  :cordinatesValue="mData.mapDataObject.value" :prop-disabled="mData.viewMode == 'accept'"
                  v-if="mData.dataDefault.showMap" id="mapBox"></mapbox-component>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <el-form-item label="Giới thiệu" prop="mo_ta">
                <el-input v-model="mData.dataForm.mo_ta"
                  :disabled="mData.viewMode == 'accept' || mData.viewMode == 'detail'" @input="forceUpdateUI"
                  type="textarea" :rows="2" clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Mô tả" prop="chi_tiet">
                <CknoimgComponent v-model="mData.dataForm.chi_tiet"
                  :prop-data-editor-disabled="mData.viewMode == 'accept' || mData.viewMode == 'detail'"
                  @blur="handleBlur('chi_tiet')"></CknoimgComponent>
              </el-form-item>
            </b-col>
          </b-row>
          <el-form-item class="text-center mt-3">
            <el-button type="danger" plain @click="fn_submitForm('not-accept')" v-ladda v-if="
              mData.viewMode == 'accept' &&
              mData.dataForm.ready == true &&
              (mData.currentUser.roles.includes('Officer') ||
                mData.currentUser.roles.includes('Admin'))
            ">Từ chối</el-button>

            <el-button type="success" plain @click="fn_submitForm('accept')" v-ladda v-if="
              mData.viewMode == 'accept' &&
              mData.dataForm.ready == true &&
              (mData.currentUser.roles.includes('Officer') ||
                mData.currentUser.roles.includes('Admin'))
            ">Duyệt</el-button>
            <el-button type="info" plain @click="fn_submitForm('update')" v-ladda v-if="mData.viewMode == 'update'">Cập
              nhật</el-button>
            <el-button type="info" plain @click="fn_submitForm('send')" v-ladda v-if="
              mData.viewMode == 'update' &&
              mData.currentUser.roles.includes('TourAgent')
            ">Gửi</el-button>

            <el-button @click="fn_go()" type="info" plain>{{ aLang.c_back }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <ModalResonTour :isShow="modal.showResonUpdateModal" :dataObject="mData.dataForm" />
  </div>
</template>

<script>
import LanguageService from '../../../service/LanguageService';
import MethodService from '../../../service/MethodService';
import DataService from '@/service/DataService';
import TourDuLichModel from './TourDuLichModel';
import ProvinceApi from '@/moduleApi/ProvinceApi';
import TourDuLichChoDuyetApi from '@/moduleApi/TourDuLichChoDuyetApi';
import CongTyLuHanhApi from '@/moduleApi/CongTyLuHanhApi';
import NenTangDichVuApi from '@/moduleApi/NenTangDichVuApi';
import ModalResonTour from '@/views/admin/TourDuLich/ModalResonTour';
import ExtensionService from "../../../service/ExtensionService";
import CknoimgComponent from "../../../component/CknoimgComponent";
import MapboxComponent from '@/component/MapboxComponent';
import ValidService from "@/service/ValidService";
import ElementUiMoney from '@/component/ElementUiMoney';
export default {
  components: {
    CknoimgComponent,
    ElementUiMoney,
    MapboxComponent,
    ModalResonTour
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      show: true,
      mData: {
        viewMode: "create",
        moduleName: "TourDuLich",
        dataDefault: {
          listNgonNgu: DataService.Languages,
          listHienThi: DataService.visibleList,
          listEndow: DataService.endowList,
          listProvince: [],
        },
        dataForm: MethodService.copyObject(TourDuLichModel.dataForm),
        fileUploadOption: MethodService.copyObject(
          TourDuLichModel.dataFormOther.fileUploadOption
        ),
        validForm: TourDuLichModel.validForm,
        currentUser: JSON.parse(localStorage.getItem('currentUser')),
        dataPropMapDiaDiem: {
          fn_addLatLng: this.fn_addLatLngDiaDiem,
          lat: "",
          lng: "",
          showMap: false,
          id: "MapDiaDiem",
        },
        mapDataObject: {
          value: [105.850176, 21.0287797],
          geoJson: {
            type: "",
            coordinates: [],
          },
        },
      },
      modal: {
        showResonUpdateModal: false
      },
      showInputMoney: false,
      showInputPercent: false,
      rulesGiaTriUuDai: [ValidService.checkGiaTriUuDaiVND(1000)],
      rulesGiaTriUuDaiPercent: [ValidService.checkGiaTriUuDaiPercent(1, 100)],
    };
  },
  async mounted() {
    let tinh_thanh = await ProvinceApi.list({
      limit: 1000
    });
    if (tinh_thanh.result) {
      this.mData.dataDefault.listProvince = tinh_thanh.result.map(item => {
        return { value: item.id, label: item.name }
      });
    }
  },
  created() {
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-accept"
    ) {
      this.mData.viewMode = "accept";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail-history"
    ) {
      this.mData.viewMode = "detail";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update-history"
    ) {
      this.mData.viewMode = "update";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  methods: {
    changeShowInput(data) {
      if (!data) return
      this.show = false
      if (parseInt(data) > 100) this.mData.dataForm.gia_tri_uu_dai = 100
      setTimeout(() => {
        this.show = true
      }, 10)
    },
    async fn_submitForm(type) {
      if (type === "not-accept") {
        this.$confirm("Xác nhận từ chối dịch vụ này?", {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.modal.showResonUpdateModal = true;
          })
          .finally(() => {
            MethodService.stopLadda();
          });
      } else {
        this.$refs["myForm"].validate(async (valid) => {
          if (valid) {
            let data = MethodService.copyObject(this.mData.dataForm);
            let uu_dai = null;
            if (this.mData.dataForm.loai_hinh_uu_dai) {
              uu_dai = this.mData.dataForm.gia_tri_uu_dai + this.mData.dataForm.loai_hinh_uu_dai;
            }
            if (type === "accept") {
              data.duyet = {
                duoc_duyet: true
              }
              await TourDuLichChoDuyetApi.approvedDichVuTour(data);
              this.fn_go();
              this.$store.commit("fn_countTourDuLich");
            } else if (type === "update") {
              if (
                this.mData.currentUser.roles.includes('Admin') ||
                this.mData.currentUser.roles.includes('Officer')
              ) {
                data.thong_tin_chung.kinh_do = this.mData.mapDataObject.value[0];
                data.thong_tin_chung.vi_do = this.mData.mapDataObject.value[1];
                data.duyet = {
                  duoc_duyet: null
                };
                data.uu_dai = uu_dai;
                await TourDuLichChoDuyetApi.update(data);
                this.fn_go();
              } else if (this.mData.currentUser.roles.includes('TourAgent')) {
                data.thong_tin_chung.kinh_do = this.mData.mapDataObject.value[0];
                data.thong_tin_chung.vi_do = this.mData.mapDataObject.value[1];
                data.duyet = {
                  duoc_duyet: null
                };
                data.ready = false;
                data.uu_dai = uu_dai;
                await TourDuLichChoDuyetApi.tourAgentupdate(data);
                this.$router.push({
                  name: "Admin-" + this.mData.moduleName + "-history"
                });
              }
              this.$store.commit("fn_countTourDuLich");
            } else if (type === "send") {
              data.thong_tin_chung.kinh_do = this.mData.mapDataObject.value[0];
              data.thong_tin_chung.vi_do = this.mData.mapDataObject.value[1];
              data.duyet = {
                duoc_duyet: null
              };
              data.ready = true;
              data.uu_dai = uu_dai;
              await TourDuLichChoDuyetApi.updateSend(data);
              this.$router.push({
                name: "Admin-" + this.mData.moduleName + "-history"
              });
              this.$store.commit("fn_countTourDuLich");
            }
          } else {
            MethodService.stopLadda();
            return false;
          }
        });
      }
    },

    fn_resetForm() {
      this.mData.dataForm = MethodService.copyObject(
        TourDuLichModel.dataForm
      );

      this.$refs["myForm"].resetFields();
    },

    async fn_getDataById(id) {
      TourDuLichChoDuyetApi.clearCache();
      let tour = await TourDuLichChoDuyetApi.findById(id);
      if (tour.result) {
        let resCongTyLuHanh = await CongTyLuHanhApi.list({
          filters: "id=" + tour.result.cong_ty_lu_hanh_id + "&$fields=id,ten,email,dien_thoai,website,dia_chi"
        });
        this.mData.dataForm = tour.result;
        let loaiHinhUuDai = undefined;
        let giaTriUuDai = "";
        if (tour.result.uu_dai) {
          loaiHinhUuDai = tour.result.uu_dai.substr(tour.result.uu_dai.length - 1);
          giaTriUuDai = tour.result.uu_dai.substr(0, tour.result.uu_dai.length - 1);
          if (loaiHinhUuDai == "K") {
            this.showInputMoney = true;
            this.showInputPercent = false;
          } else if (loaiHinhUuDai == "%") {
            this.showInputMoney = false;
            this.showInputPercent = true;
          }
        }
        this.$set(this.mData.dataForm, "loai_hinh_uu_dai", loaiHinhUuDai);
        this.$set(this.mData.dataForm, "gia_tri_uu_dai", giaTriUuDai);
        this.mData.dataForm.cong_ty_lu_hanh = resCongTyLuHanh.result[0];

        let nen_tang_dich_vu = await NenTangDichVuApi.list({
          filters: "dich_vu=Tour&hien_thi=true"
        });
        if (nen_tang_dich_vu.result) {
          for (const element of nen_tang_dich_vu.result) {
            if (
              tour.result.thong_tin_chung.link_dich_vu &&
              tour.result.thong_tin_chung.link_dich_vu.find(x => x.id == element.id)
            ) {
              element.link = tour.result.thong_tin_chung.link_dich_vu.find(x => x.id == element.id).link;
            } else {
              element.link = "";
            }
          }
        }
        this.mData.dataForm.thong_tin_chung.link_dich_vu = nen_tang_dich_vu.result;

        if (!this.mData.dataForm.thong_tin_chung.link_mang_xa_hoi) {
          this.mData.dataForm.thong_tin_chung.link_mang_xa_hoi = [
            {
              name: 'Facebook',
              link: undefined
            },
            {
              name: 'Zalo',
              link: undefined
            },
            {
              name: 'Youtube',
              link: undefined
            },
            {
              name: 'Google',
              link: undefined
            },
            {
              name: 'Twitter',
              link: undefined
            }
          ]
        }

        if (tour.result.mediaId) {
          let data = {
            id: tour.result.mediaId,
            name: tour.result.mediaId,
            url: ExtensionService.urlImg + tour.result.mediaId
          };
          this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
        }
        if (tour.result.thong_tin_chung.kinh_do == undefined ||
          tour.result.thong_tin_chung.vi_do == undefined
        ) {
          this.mData.dataForm.thong_tin_chung.kinh_do = 105.850176;
          this.mData.dataForm.thong_tin_chung.vi_do = 21.0287797;
        }
        this.mData.dataPropMapDiaDiem.lat = this.mData.dataForm.thong_tin_chung.vi_do;
        this.mData.dataPropMapDiaDiem.lng = this.mData.dataForm.thong_tin_chung.kinh_do;
        this.mData.dataPropMapDiaDiem.showMap = true;
        let coordinate = [
          this.mData.dataForm.thong_tin_chung.kinh_do,
          this.mData.dataForm.thong_tin_chung.vi_do
        ];
        this.mData.mapDataObject.value = coordinate;
        this.mData.mapDataObject.geoJson.type = "Point";
        this.mData.mapDataObject.geoJson.coordinates = coordinate;
        this.mData.dataDefault.showMap = true;
      }
    },
    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      return resData;
    },

    fn_selectTypeEndow(e) {
      if (e == "K") {
        this.showInputMoney = true;
        this.showInputPercent = false;
      } else if (e == "%") {
        this.showInputMoney = false;
        this.showInputPercent = true;
      } else {
        this.showInputMoney = false;
        this.showInputPercent = false;
      }
      this.$set(this.mData.dataForm, "gia_tri_uu_dai", "");
      this.$nextTick(() => {
        if (this.$refs["myForm"]) {
          this.$refs["myForm"].clearValidate("gia_tri_uu_dai");
        }
      });
    },

    fn_go() {
      this.$router.go(-1);
    },

    fn_uploadRemoveAnhDaiDien() {
      this.mData.dataForm.mediaId = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
      this.$refs["myForm"].validateField('mediaId');
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "TourDuLich")
        .then(res => {
          this.mData.dataForm.mediaId = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
          this.$refs["myForm"].validateField('mediaId');
        })
        .catch(() => {
          this.$refs["myForm"].validateField('mediaId');
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien() {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },
    fn_getDataFromMapboxComponent(value) {
      this.mData.mapDataObject = value;
    },
    handleBlur(prop) {
      this.$refs["myForm"].validateField(prop);
    },
    handleInputGiaTriUuDai(val) {
      this.$set(this.mData.dataForm, "gia_tri_uu_dai", val);
      if (this.$refs["myForm"]) {
        this.$refs["myForm"].clearValidate("gia_tri_uu_dai");
      }
      this.forceUpdateUI();
    },
    forceUpdateUI() {
      this.$forceUpdate();
    }
  },
  computed: {
    getStatusName() {
      if (this.mData.dataForm.ready) {
        return "Chờ duyệt";
      } else if (!this.mData.dataForm.duyet.duoc_duyet) {
        return "Từ chối";
      } else if (!this.mData.dataForm.ready) {
        return "Đang soạn thảo";
      } else {
        return "";
      }
    },
  }
}
</script>
<style>
@media (min-width: 1220px) {
  .col-custom {
    max-width: 20%;
  }
}
</style>
